// Translations
import tosDialog from '../components/tos-dialog/translations/en'

// Translation: Register > Landing > Form (English)
export default Object.freeze({
	components: { tosDialog },
	form: {
		actions: {
			continue: 'Continue',
			register: 'Register'
		},
		fields: {
			email: {
				placeholder: 'Enter your email'
			},
			firstName: {
				placeholder: 'Enter your first name'
			},
			lastName: {
				placeholder: 'Enter your last name'
			},
			password: {
				placeholder: 'Enter your password'
			},
			passwordConfirmation: {
				placeholder: 'Confirm your password'
			}
		},
		options: {
			login: {
				action: 'Login',
				label: 'Already have an account?'
			}
		},
		title: {
			accountInformation: 'Account information',
			profileDetails: 'Profile details'
		}
	}
})
